module.exports = __webpack_public_path__ + "img/avataruniverse.effe0732.jpg";